import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios';
import { withGlobalError } from '@/react-tools/react-query';

import { StackFile, StackId } from '../types';

import { queryKeys } from './query-keys';

export function useStackFile(stackId?: StackId) {
  return useQuery(queryKeys.stackFile(stackId), () => getStackFile(stackId), {
    ...withGlobalError('Unable to retrieve stack'),
    enabled: !!stackId,
  });
}

async function getStackFile(stackId?: StackId) {
  if (!stackId) {
    return Promise.resolve(undefined);
  }
  try {
    const { data } = await axios.get<StackFile>(`/stacks/${stackId}/file`);
    return data;
  } catch (e) {
    throw parseAxiosError(e, 'Unable to retrieve stack file');
  }
}
